import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import classnames from 'classnames';
import styles from "./TwoItemSwiper.module.scss";
import { Swiper, SwiperSlide } from 'swiper/react';
import { useRef, useState } from 'react';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var TwoItemSwiper = function TwoItemSwiper(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$innerClassName = _ref.innerClassName,
    innerClassName = _ref$innerClassName === void 0 ? '' : _ref$innerClassName;
  var swiperRef = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  var navigatePrev = function navigatePrev(index) {
    var _swiperRef$current, _swiperRef$current2, _swiperRef$current2$s;
    if (swiperRef !== null && swiperRef !== void 0 && (_swiperRef$current = swiperRef.current) !== null && _swiperRef$current !== void 0 && _swiperRef$current.swiper && activeIndex === index) {
      swiperRef.current.swiper.slidePrev();
    }
    setActiveIndex((swiperRef === null || swiperRef === void 0 ? void 0 : (_swiperRef$current2 = swiperRef.current) === null || _swiperRef$current2 === void 0 ? void 0 : (_swiperRef$current2$s = _swiperRef$current2.swiper) === null || _swiperRef$current2$s === void 0 ? void 0 : _swiperRef$current2$s.activeIndex) || 0);
  };
  return /*#__PURE__*/_jsx("div", {
    className: styles.twoItemSwiper,
    children: /*#__PURE__*/_jsx("div", {
      className: styles.sliderContainer,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.container,
        children: items && /*#__PURE__*/_jsx(Swiper, {
          onBeforeSlideChangeStart: function onBeforeSlideChangeStart() {
            var _swiperRef$current3, _swiperRef$current3$s;
            setActiveIndex((swiperRef === null || swiperRef === void 0 ? void 0 : (_swiperRef$current3 = swiperRef.current) === null || _swiperRef$current3 === void 0 ? void 0 : (_swiperRef$current3$s = _swiperRef$current3.swiper) === null || _swiperRef$current3$s === void 0 ? void 0 : _swiperRef$current3$s.activeIndex) || 0);
          },
          ref: swiperRef,
          slidesPerView: "auto",
          className: styles.swiper,
          spaceBetween: 16,
          slideToClickedSlide: true,
          children: items.map(function (item, index) {
            return /*#__PURE__*/_jsx(SwiperSlide, {
              className: styles.swiperSlide,
              children: /*#__PURE__*/_jsxs("div", {
                onClick: function onClick() {
                  return navigatePrev(index);
                },
                className: classnames(styles.innerSwiper, innerClassName),
                children: [item.FirstItem, item.SecondItem]
              })
            }, index);
          })
        })
      })
    })
  });
};